"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { onImageChange } from "@/libs/builder/common/onImageChange";
import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const promoCardVerticalInputs = [
  {
    name: "imageUrl",
    friendlyName: "Image (mobile)",
    helperText: "Used on mobile and as fallback for breakpoints without a dedicated image.",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F035813b7aeb845139d31942675bcbb18",
    onChange: onImageChange,
  },
  {
    name: "tabletImageUrl",
    friendlyName: "Image (tablet)",
    helperText: "Optional. Used from 768px up. Falls back to the mobile image.",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue: "",
    onChange: onImageChange,
  },
  {
    name: "desktopImageUrl",
    friendlyName: "Image (desktop)",
    helperText: "Optional. Used from 1280px up. Falls back to the tablet or mobile image.",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue: "",
    onChange: onImageChange,
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Lorem ipsum dolor",
  },
  {
    name: "imageAlt",
    friendlyName: "Image Alt Text",
    type: "string",
    defaultValue: "",
  },
  {
    name: "url",
    type: "url",
    required: true,
    defaultValue: "/",
  },
  {
    name: "dominantColor",
    type: "string",
    hideFromUI: true,
    defaultValue: "",
  },
  {
    name: "tabletDominantColor",
    type: "string",
    hideFromUI: true,
    defaultValue: "",
  },
  {
    name: "desktopDominantColor",
    type: "string",
    hideFromUI: true,
    defaultValue: "",
  },
] as const satisfies Inputs;

export const PromoCardVerticalComponent: RegisteredComponent = {
  name: "PromoCardVertical",
  component: dynamic(async () =>
    withValidation(
      promoCardVerticalInputs,
      (await import("./PromoCardVertical")).PromoCardVertical,
      "PromoCardVertical"
    )
  ),
  inputs: promoCardVerticalInputs,
};
